import { useState } from "react";

export const useRefresh = () => {
    const [refreshId, setRefreshId] = useState(Math.random());


    const refresh = () => {
        setRefreshId(Math.random());
    }

    return {
        refreshId,
        refresh
    }
}